// extracted by mini-css-extract-plugin
module.exports = {"filterBlock":"orgList_filterBlock__1zdZA","filterBlock__inner":"orgList_filterBlock__inner__2whSX"};